// (C) Copyright 2025 Hewlett Packard Enterprise Development LP
import { useNavigate } from 'react-router-dom'

import { MenuList } from '../../../components'
import { isMSPTenantCoP, isCoP } from '../../../utils/feature-flag-utils'

const CloudConsoleMenu = () => {
  const navigate = useNavigate()

  const handleCloudConsoleMenuItemClick = (item) => {
    if (item.linkTo.includes('http')) {
      window.open(item.linkTo, '_blank')
    } else {
      navigate(item.linkTo)
    }
  }
  return (
    <MenuList
      navStyles={{
        padding: 'none',
        gap: 'none'
      }}
      menuData={[
        {
          id: 1,
          label: 'HPE GreenLake Central',
          linkTo: 'https://client.greenlake.hpe.com',
          testId: 'header-apps-hpe-green-lake-central',
          isHidden: () => isCoP()
        },
        {
          id: 2,
          label: 'Data Services',
          linkTo: '/applications/available-apps',
          testId: 'header-apps-data-services',
          isHidden: () => isMSPTenantCoP()
        },
        {
          id: 3,
          label: 'Compute Ops Management',
          linkTo: '/applications/available-apps',
          testId: 'header-apps-compute-ops-management',
          isHidden: () => isMSPTenantCoP()
        },

        {
          id: 4,
          label: 'Aruba Central',
          linkTo: 'https://portal.central.arubanetworks.com',
          testId: 'header-apps-aruba-central',
          isHidden: () => isCoP()
        }
      ]}
      onClickMenuItem={handleCloudConsoleMenuItemClick}
      testId="cloud-console-menu"
    />
  )
}

export { CloudConsoleMenu }
